"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeightPerLengthJson = exports.WeightPerLength = exports.WeightPerLengthUnitText = exports.WeightPerLengthUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var WeightPerLengthUnits;
(function (WeightPerLengthUnits) {
    WeightPerLengthUnits["norm"] = "kg_km";
    WeightPerLengthUnits["kg_km"] = "kg_km";
    WeightPerLengthUnits["kg_m"] = "kg_m";
    WeightPerLengthUnits["g_m"] = "g_m";
    WeightPerLengthUnits["lbs_mft"] = "lbs_mft";
    WeightPerLengthUnits["lbs_ft"] = "lbs_ft";
})(WeightPerLengthUnits = exports.WeightPerLengthUnits || (exports.WeightPerLengthUnits = {}));
exports.WeightPerLengthUnitText = {
    [WeightPerLengthUnits.norm]: 'kg/km',
    [WeightPerLengthUnits.kg_km]: 'kg/km',
    [WeightPerLengthUnits.kg_m]: 'kg/m',
    [WeightPerLengthUnits.g_m]: 'g/m',
    [WeightPerLengthUnits.lbs_mft]: 'lbs/mft',
    [WeightPerLengthUnits.lbs_ft]: 'lbs/ft',
};
class WeightPerLength extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'WeightPerLength';
        this.type = this.className;
        this.defaultUnit = 'kg_km';
        this.unitTexts = exports.WeightPerLengthUnitText;
    }
    static getUnitText(unit) {
        return exports.WeightPerLengthUnitText[unit];
    }
    static fromJson(q) {
        if (!(0, echain_shared_ts_utils_1.isValueInEnum)(WeightPerLengthUnits, q.Unit)) {
            throw new Error(`WeightPerLength.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new WeightPerLength(q);
    }
    static kg_km(v) {
        return new WeightPerLength(v, WeightPerLengthUnits.kg_km);
    }
    static kg_m(v) {
        return new WeightPerLength(v, WeightPerLengthUnits.kg_m);
    }
    static g_m(v) {
        return new WeightPerLength(v, WeightPerLengthUnits.g_m);
    }
    static lbs_ft(v) {
        return new WeightPerLength(v, WeightPerLengthUnits.lbs_ft);
    }
    static lbs_mft(v) {
        return new WeightPerLength(v, WeightPerLengthUnits.lbs_mft);
    }
    set kg_km(v) {
        this.value = v;
        this.unit = WeightPerLengthUnits.kg_km;
    }
    get kg_km() {
        return this.unit === WeightPerLengthUnits.kg_km ? this.value : this.kg_m * 1000;
    }
    set kg_m(v) {
        this.value = v;
        this.unit = WeightPerLengthUnits.kg_m;
    }
    get kg_m() {
        switch (this.unit) {
            case WeightPerLengthUnits.kg_km:
            case WeightPerLengthUnits.g_m:
                return this.value / 1000;
            case WeightPerLengthUnits.kg_m:
                return this.value;
            case WeightPerLengthUnits.lbs_ft:
                return this.value * 1.488164;
            case WeightPerLengthUnits.lbs_mft:
                return (this.value * 1.488164) / 1000;
        }
        throw new Error(`${this.className}.kg_m: unknown unit ${this.unit}`);
    }
    set g_m(v) {
        this.value = v;
        this.unit = WeightPerLengthUnits.g_m;
    }
    get g_m() {
        return this.unit === WeightPerLengthUnits.g_m ? this.value : this.kg_m * 1000;
    }
    set lbs_ft(v) {
        this.value = v;
        this.unit = WeightPerLengthUnits.lbs_ft;
    }
    get lbs_ft() {
        return this.unit === WeightPerLengthUnits.lbs_ft ? this.value : this.kg_m / 1.488164;
    }
    set lbs_mft(v) {
        this.value = v;
        this.unit = WeightPerLengthUnits.lbs_mft;
    }
    get lbs_mft() {
        return this.unit === WeightPerLengthUnits.lbs_mft ? this.value : this.lbs_ft * 1000;
    }
    clone() {
        return WeightPerLength.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case WeightPerLengthUnits.kg_km:
                return this.kg_km;
            case WeightPerLengthUnits.kg_m:
                return this.kg_m;
            case WeightPerLength.units.g_m:
                return this.g_m;
            case WeightPerLengthUnits.lbs_ft:
                return this.lbs_ft;
            case WeightPerLengthUnits.lbs_mft:
                return this.lbs_mft;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
    }
}
exports.WeightPerLength = WeightPerLength;
WeightPerLength.units = WeightPerLengthUnits;
const isWeightPerLengthJson = (l) => {
    return (0, Quantity_1.isQuantityJson)(l) && (0, echain_shared_ts_utils_1.isValueInEnum)(WeightPerLengthUnits, l.Unit);
};
exports.isWeightPerLengthJson = isWeightPerLengthJson;
//# sourceMappingURL=WeightPerLength.js.map